import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import { YML_Vessel_Schedule } from '../types';

interface VesselMarkerProps {
  vessel: YML_Vessel_Schedule;
  containerCount: number;
  selected?: boolean;
  onClick: (vessel: YML_Vessel_Schedule) => void;
}

// Icon-ul de bază pointează spre dreapta (90°). Heading-ul navelor are 0 = nord,
// deci aplicăm rotirea `heading - 90`. Folosim paleta claude_design prin
// CSS variables; fallback solid dacă nu sunt setate.
const shipSvg = (size = 18) => `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="currentColor">
  <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
</svg>
`;

const createVesselIcon = (count: number, heading: number = 0, selected = false) => {
  const rotation = heading - 90;
  const ring = selected ? 'box-shadow: 0 0 0 6px var(--accent-soft, rgba(245,184,0,0.18));' : '';

  return L.divIcon({
    html: `
      <div style="
        position: relative;
        width: 32px;
        height: 32px;
        display: grid;
        place-items: center;
        transform: rotate(${rotation}deg);
        transition: transform 0.5s ease-in-out;
      ">
        <div style="
          width: 28px;
          height: 28px;
          border-radius: 999px;
          background: var(--accent, #f5b800);
          color: var(--accent-fg, #1a1a18);
          display: grid;
          place-items: center;
          border: 1.5px solid var(--surface, #fff);
          box-shadow: 0 2px 6px rgba(0,0,0,0.18);
          ${ring}
        ">
          ${shipSvg(16)}
        </div>
        <div style="
          position: absolute;
          top: -4px;
          right: -4px;
          min-width: 18px;
          height: 18px;
          padding: 0 5px;
          border-radius: 999px;
          background: var(--text, #2b2a25);
          color: var(--surface, #fff);
          font-size: 10px;
          font-weight: 700;
          line-height: 1;
          display: grid;
          place-items: center;
          border: 1.5px solid var(--surface, #fff);
          transform: rotate(${-rotation}deg);
          box-shadow: 0 1px 3px rgba(0,0,0,0.25);
          font-family: var(--font-sans, system-ui);
        ">${count}</div>
      </div>
    `,
    className: 'custom-vessel-marker',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
  });
};

export const VesselMarker: React.FC<VesselMarkerProps> = ({
  vessel,
  containerCount,
  selected,
  onClick,
}) => {
  const icon = createVesselIcon(containerCount, vessel.currentLocation.heading, selected);

  return (
    <Marker
      position={[vessel.currentLocation.lat, vessel.currentLocation.lng]}
      icon={icon}
      eventHandlers={{ click: () => onClick(vessel) }}
    >
      <Tooltip direction="top" offset={[0, -14]} opacity={1}>
        <div
          style={{
            fontFamily: 'var(--font-sans, system-ui)',
            color: 'var(--text, #2b2a25)',
            minWidth: 140,
          }}
        >
          <div style={{ fontWeight: 600, fontSize: 13 }}>{vessel.vesselName}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted, #6b6b66)', marginTop: 2 }}>
            Voiaj <span className="mono">{vessel.voyageCode}</span>
          </div>
        </div>
      </Tooltip>
    </Marker>
  );
};
